import React, { useCallback, useState } from 'react';

import { Box, Button, Stack, TextField, Typography } from '@mui/material';

import { Property, PropertyAutocomplete } from '~/components/Common/CustomOffers/PropertyAutocomplete';
import PropertyRelationsSearchResultsContainer from '~/components/Vendors/Home/PropertyRelationsSearchResultsContainer';

const isValidSearchQuery = (query: string) => /^\S{1,36}$/.test(query);

function PropertyRelationsForm() {
  const [searchQuery, setSearchQuery] = useState('');
  const [submittedSearchId, setSubmittedSearchId] = useState<string | null>(null);
  const [searchFailed, setSearchFailed] = useState(false);

  const [propertyFilter, setPropertyFilter] = useState<Property | null>(null);
  const [propertyInputValue, setPropertyInputValue] = useState('');

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handlePropertySelect = useCallback((property: Property | null) => {
    setPropertyFilter(property);
  }, []);

  const handlePropertyInputChange = useCallback((value: string) => {
    setPropertyInputValue(value);
    if (!value) {
      setPropertyFilter(null);
    }
  }, []);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const trimmedQuery = searchQuery.trim();

    if (!isValidSearchQuery(trimmedQuery)) {
      setSearchFailed(true);
      setSubmittedSearchId(null);
      return;
    }

    setSearchFailed(false);
    setSubmittedSearchId(trimmedQuery);
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Stack direction="row" spacing={2} alignItems="center">
          <Box flex={1}>
            <TextField
              id="RelationsSearch"
              data-testid="RelationsSearch"
              type="text"
              name="searchRelations"
              label="Enter Search ID"
              placeholder="Search by Rate Plan ID, Rate Plan Code, Room Type ID, Room Type Code or Room Rate ID"
              value={searchQuery}
              onChange={handleSearchChange}
              autoFocus
              inputProps={{ maxLength: 36, minLength: 1 }}
              required
              fullWidth
            />
          </Box>

          <Box flex={1}>
            <PropertyAutocomplete
              value={propertyInputValue}
              onPropertySelect={handlePropertySelect}
              onInputChange={handlePropertyInputChange}
              label="Filter by Property"
              placeholder="Type to search properties (optional)"
            />
          </Box>

          <Button type="submit" variant="contained" className="T-search-user">
            Search
          </Button>
        </Stack>
      </form>

      <Box mt={4}>
        {searchFailed && <Typography variant="subtitle1">No relations found by your request...</Typography>}
        {submittedSearchId && (
          <PropertyRelationsSearchResultsContainer searchId={submittedSearchId} propertyId={propertyFilter?.id} />
        )}
      </Box>
    </>
  );
}

export default PropertyRelationsForm;
